import renderEnvComponent from 'data/common/renderEnvComponent';
import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core';
import { FHEContainer } from 'data/components';
import { tools } from 'data/common';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import FormBrand from './components/Form/FormBrand';
import { addBrand } from '../../data/Brands/actions';

class BrandAdd extends PureComponent {
    static propTypes = {
        addBrand: PropTypes.func.isRequired,
    };

    addBrand = data => {
        const { addBrand } = this.props;
        return addBrand(data);
    };
    render() {
        return (
            <FHEContainer withBackIcon>
                <FormBrand type="add" sendDataFunc={this.addBrand} />
            </FHEContainer>
        );
    }
}

const styles = theme => ({});

export default withRouter(
    renderEnvComponent(
        'scenes/Brands/add',
        connect(
            null,
            (dispatch, ownProps) => bindActionCreators(tools.mergePropsToAction(ownProps.history.environment, { addBrand }), dispatch),
        )(withStyles(styles, { withTheme: true })(BrandAdd)),
    ),
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Brands/add.js